<template>
    <div class="feed-back">
        <div data-name="feedback-text">
            <p v-if="isReceiver">
                &quot; <b>{{request.sender.title}}</b> &quot; requests <b>{{(request.receiver.spot_position + 1) | ordinal}}</b>  spot on an Update you post on <b>{{request.receiver.update_date._seconds | secondsToDateMonth}}</b>. 
                In exchange, they offer their <b>{{(request.sender.spot_position + 1) | ordinal}}</b> spot in an Update they post on <b>{{request.sender.update_date._seconds | secondsToDateMonth}}</b>.
            </p>
            <p v-else>
                You requested <b>{{(request.receiver.spot_position + 1) | ordinal}}</b> spot on an Update &quot;<b>{{request.receiver.title}}</b>&quot; posts on <b>{{request.receiver.update_date._seconds | secondsToDateMonth}}</b>. 
                You offered your <b>{{(request.sender.spot_position + 1) | ordinal}}</b> spot in an Update you post on <b>{{request.sender.update_date._seconds | secondsToDateMonth}}</b>.
            </p>
        </div>
        <div data-name="feedback-footer" :class="{'justify-content-end' : !showCounterOffer}">
            <div data-name="send-counter-offer" v-if="showCounterOffer">
                <p @click="conterOffer">Send Counter Offer</p>
                <Icon icon="hint-dark-icon"/>
            </div>
            <Actions 
                @setRequestData="setRequestData" 
                v-if="request.status === 'pending'" 
                :request-data="request"/>
        </div>
    </div>
</template>

<script>
import Button from '../../../Button'
import Icon from '@/components/Theme/Icon'
import {truncate, numbers, dates} from '../../../../../../core/filters'
import {Actions} from '../../TableComponents'

export default {
    name: 'FeedBack',
    components: {
        Button,
        Icon,
        Actions
    },
    props: {
        setRequestData: Function,
        request: Object
    },
    filters: {
        truncate,
        ordinal: numbers.ordinal,
        secondsToDateMonth: dates.secondsToDateMonth
    },
    computed: {
        showCounterOffer(){
            return (!this.$route.query.type || this.$route.query.type === 'received') && this.request.status === 'pending'
        },
        isReceiver(){
            return !this.$route.query.type || this.$route.query.type === 'received'
        }
    },
    methods: {
        conterOffer() { 
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    project_id: this.request.sender.campaign,
                    counterOffer: this.request.id,
                    oldRequestDate: this.request.created_date
                }
            }).catch(() => {})
            this.$store.commit('TOGGLE_MODAL', ['cp-request', true])
            this.$ga.event('CpRequest', 'Modal Opened', `
                Location: Dashboard Counter Offer,
                Campaign: ${this.request.sender.title},
                IsCounterOffer: true
            `)
            this.$sendMixpanelEvent('Request Crossprom Modal Opened', {
                'Button Location': 'Dashboard Counter Offer',
                'Campaign Name': this.request.sender.title,
                'Is Counter Offer': true
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/variables.scss';
div.feed-back {
    width: 100%;
    // width: 446px;
    display: flex;
    flex-direction: column;
    height: 134px;
    background: $c14;
    box-shadow: 0px 1px 2px rgba(8, 35, 48, 0.02), 0px 2px 12px rgba(8, 35, 48, 0.08), 0px -1px 2px rgba(8, 35, 48, 0.02);
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 16px;
    div[data-name="feedback-text"] {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        padding-bottom: 6px;
        p {
            color: $c6;
            font-size: $p5;
        }
    }
    div[data-name="feedback-footer"] {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: auto;
        margin-bottom: 8px;

        div[data-name="send-counter-offer"] {
            display: flex;
            align-items: center;
            p {
                color: $c3;
                font-size: $p5;
                margin-right: 6px;
                cursor: pointer;
                
                &:hover {
                    color: $c6;
                }
            }
        }
    }
}
</style>